import { Button, Checkbox, Grid, Typography } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import useRazorpay from 'react-razorpay';
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
const AddPayment = ({ registrationFeeDetails, alumniDetails }) => {

    const RequestId = useRequestIdGenerater();
    const { rendomRequestId, generateTimeStamp } = useTimeStamp();
    const [Razorpay] = useRazorpay();
    const [selectedFees, setSelectedFees] = useState([])

    // const handleFeeSelection = (fee) => {
    //     setSelectedFees((prevSelected) =>
    //         prevSelected.some((item) => item.id === fee.id)
    //             ? prevSelected.filter((item) => item.id !== fee.id)
    //             : [...prevSelected, fee]
    //     );
    // };

    const createOrder = async () => {
        if (selectedFees.length === 0) {
            alert("Please select at least one fee to proceed.");
            return;
        }

        const totalAmount = selectedFees.reduce((sum, fee) => sum + fee.amount, 0);

        const payload = {
            amount: totalAmount * 100,
            feeDetails: selectedFees.map((fee) => ({
                feeMappingId: fee.id,
                paidAmount: fee.amount
            }))
        };

        try {
            const { data } = await axios.post(`/v1/fee/payment-create-orderId`, payload, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json',
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                    ),
                }
            });

            const orderId = data.data; // Extract order_id from response

            const options = {
                key: process.env.RAZOR_PAY_KEY,
                amount: totalAmount * 100,
                currency: 'INR',
                name: 'DPS Alumni',
                description: 'Fee Payment',
                order_id: orderId,
                handler: handlePaymentSuccess,
                prefill: {
                    name: alumniDetails.studentName,
                    email: alumniDetails.email,
                    contact: alumniDetails.phoneNo
                },
                notes: {
                    name: alumniDetails.studentName,
                    regNo: alumniDetails.regNo,
                    phone: alumniDetails.phoneNo,
                    takenFrom: 'Fee Payment'
                },
                theme: { color: '#3399cc' },
                modal: {
                    ondismiss: async () => {
                        try {
                            const response = await axios.get(`/v1/fee/payment-status?orderId=${orderId}`, {
                                headers: {
                                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                                    'Content-Type': 'application/json',
                                    requestId: RequestId(
                                        Math.floor(1000 + Math.random() * 9999),
                                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                                    ),
                                }
                            });

                            if (response.status === 200) {
                                const parsedResponse = JSON.parse(response.data.data);
                                const data = {
                                    failedResponse: response.error || null,
                                    feeDetails: [{
                                        feeMappingId: registrationFeeDetails[0].id,
                                        payment: registrationFeeDetails[0]?.amount
                                    }],
                                    orderId: parsedResponse?.id,
                                    paymentId: response.razorpay_payment_id,
                                    signature: response.razorpay_signature,
                                    success: false
                                };

                                await axios.post(`/v1/fee/payment-collect`, data, {
                                    headers: {
                                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                                        'Content-Type': 'application/json',
                                        requestId: RequestId(
                                            Math.floor(1000 + Math.random() * 9999),
                                            Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                                        ),
                                    }
                                });

                                setSelectedFees([])
                                dispatch(openSnackbar({
                                    open: true,
                                    message: 'Payment Cancelled!',
                                    variant: 'alert',
                                    alert: { color: 'error' },
                                    close: false
                                }));
                            }
                        } catch (error) {
                            console.error("Payment status fetch failed:", error);
                        }
                        alert('Payment Cancelled');
                    }
                }
            };

            const rzp1 = new Razorpay(options);
            rzp1.on('payment.failed', async (response) => {
                const data = {
                    failedResponse: JSON.stringify(response.error),
                    feeDetails: [{
                        feeMappingId: registrationFeeDetails[0].id,
                        payment: registrationFeeDetails[0]?.amount
                    }],
                    orderId: response?.error?.metadata?.order_id,
                    paymentId: response?.error?.metadata?.payment_id,
                    signature: '',
                    success: false
                };

                await axios.post(`/v1/fee/payment-collect`, data, {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json',
                        requestId: RequestId(
                            Math.floor(1000 + Math.random() * 9999),
                            Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                        ),
                    }
                });
                setSelectedFees([])

                window.location.reload();
            });
            rzp1.open();
        } catch (error) {
            console.error("Error creating payment order:", error);
            alert("Failed to initiate payment. Please try again.");
        }
    };


    const handlePaymentSuccess = async (response) => {
        try {
            const data = {
                failedResponse: response.error || null,
                feeDetails: selectedFees.map((fee) => ({
                    feeMappingId: fee.id,
                    payment: fee.amount
                })),
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id,
                signature: response.razorpay_signature,
                success: true
            };

            await axios.post(`/v1/fee/payment-collect`, data, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json',
                    requestId: RequestId(
                        Math.floor(1000 + Math.random() * 9999),
                        Math.floor(1000 + Math.random() * 9999) + rendomRequestId
                    ),
                }
            });
            setSelectedFees([])
            dispatch(openSnackbar({
                open: true,
                message: 'Payment Completed Successfully!',
                variant: 'alert',
                alert: { color: 'success' },
                close: false
            }));
            window.location.reload();
        } catch (error) {
            console.error("Payment collection failed:", error);
        }
    };

    useEffect(() => {
        const mandatoryFees = registrationFeeDetails.filter(fee => fee.mandatory);
        setSelectedFees(mandatoryFees);
        generateTimeStamp();
    }, [registrationFeeDetails]); // Runs when registrationFeeDetails changes

    const handleFeeSelection = (fee) => {
        if (fee.mandatory) return; // Prevent unchecking mandatory fees

        setSelectedFees((prevSelected) =>
            prevSelected.some((item) => item.id === fee.id)
                ? prevSelected.filter((item) => item.id !== fee.id)
                : [...prevSelected, fee]
        );
    };

    useEffect(() => {
        generateTimeStamp()
    }, [])

    return (
        <Grid sx={{ display: "flex", justifyContent: "center" }}>
            <Grid
                md={12}
                sx={{
                    p: 2,
                    border: "2px solid #F2DDD9",
                    background: "#D5E0EC",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                }}
            >
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", mb: 2 }}>
                    Select Fees to Pay
                </Typography>

                {registrationFeeDetails.map((fee) => (
                    <Grid key={fee.id} sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                        <Checkbox
                            checked={selectedFees.some((item) => item.id === fee.id) || fee.mandatory}
                            onChange={() => handleFeeSelection(fee)}
                            disabled={fee.mandatory} // Disable checkbox if it's mandatory
                        />
                        <Typography>{fee.feeHeads.name} - ₹{fee.amount}</Typography>
                    </Grid>
                ))}


                <Button
                    variant="contained"
                    color="primary"
                    sx={{ mt: 2 }}
                    onClick={createOrder}
                    disabled={selectedFees.length === 0}
                >
                    Pay ₹{selectedFees.reduce((sum, fee) => sum + fee.amount, 0)}
                </Button>

                <Typography sx={{ fontSize: "16px", mt: 2 }}>
                    Secure your spot by completing the payment. Your registration will be confirmed once the transaction has been successfully processed.
                </Typography>
            </Grid>
        </Grid>
    );
};


export default AddPayment